module.exports = __webpack_public_path__ + "static/img/43.9c899a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/43.png
// module id = cguC
// module chunks = 0